module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/app/lang/ja.json
// module id = RP/V
// module chunks = 1